// extracted by css-extract-rspack-plugin
export default {"Button":"invalid-config-error-module__Button__uqpPq"};